const emailDomainStatus = (domain) => {
  if (domain.ready_for_campaigns === true) {
    return {
      label: "Verified",
      description: "DNS and secure tracking are verified.",
    };
  }

  switch (domain.https_tracking?.status) {
    case "pending":
      return {
        label: "HTTPS pending",
        description:
          "Secure tracking is being set up. This can take a few minutes. Refresh the status to check progress.",
      };
    case "waiting_dns":
    case "active":
      return {
        label: "DNS pending",
        description:
          "Check the required DNS records, then authenticate the domain again.",
      };
    case "error":
    case "failed":
      return {
        label: "HTTPS setup failed",
        description:
          "Secure tracking could not be confirmed. Check your DNS records and authenticate again. Contact support if this continues.",
      };
    default:
      return {
        label: "HTTPS unverified",
        description:
          "Authenticate the domain to check DNS and start secure tracking setup.",
      };
  }
};

export default emailDomainStatus;
